/**
 * 模板管理相关API
 */
import { TemplateDetail, TemplateListResponse } from '../types';

const API_URL = process.env.REACT_APP_API_URL ?? '';

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${localStorage.getItem('token')}`,
});

async function parseJsonResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let detail = `请求失败（${response.status}）`;
    try {
      const body = await response.json();
      if (typeof body?.detail === 'string') detail = body.detail;
    } catch {
      // 非 JSON 错误响应保留状态码提示
    }
    throw new Error(detail);
  }
  return response.json() as Promise<T>;
}

export const templateApi = {
  // 获取模板列表
  getTemplates: (params?: {
    category?: string;
    industry?: string;
    is_public?: boolean;
    search?: string;
    page?: number;
    page_size?: number;
  }) => {
    const searchParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          searchParams.append(key, String(value));
        }
      });
    }
    const qs = searchParams.toString();
    return fetch(`${API_URL}/api/templates${qs ? `?${qs}` : ''}`, {
      headers: { ...getAuthHeaders() },
    }).then(res => parseJsonResponse<TemplateListResponse>(res));
  },

  // 获取模板详情
  getTemplate: (id: number) =>
    fetch(`${API_URL}/api/templates/${id}`, {
      headers: { ...getAuthHeaders() },
    }).then(res => parseJsonResponse<TemplateDetail>(res)),

  // 创建模板（multipart）
  createTemplate: (formData: FormData) =>
    fetch(`${API_URL}/api/templates`, {
      method: 'POST',
      headers: { ...getAuthHeaders() },
      body: formData,
    }).then(res => parseJsonResponse<TemplateDetail>(res)),

  // 更新模板（multipart，所有字段可选）
  updateTemplate: (id: number, formData: FormData) =>
    fetch(`${API_URL}/api/templates/${id}`, {
      method: 'PUT',
      headers: { ...getAuthHeaders() },
      body: formData,
    }).then(res => parseJsonResponse<TemplateDetail>(res)),

  // 删除模板
  deleteTemplate: (id: number) =>
    fetch(`${API_URL}/api/templates/${id}`, {
      method: 'DELETE',
      headers: { ...getAuthHeaders() },
    }).then(res => parseJsonResponse<Record<string, unknown>>(res)),

  // 重新解析模板
  reparseTemplate: (id: number) =>
    fetch(`${API_URL}/api/templates/${id}/parse`, {
      method: 'POST',
      headers: { ...getAuthHeaders() },
    }).then(res => parseJsonResponse<TemplateDetail>(res)),

  // 获取分类列表
  getCategories: () =>
    fetch(`${API_URL}/api/templates/categories/list`, {
      headers: { ...getAuthHeaders() },
    }).then(res => parseJsonResponse<string[]>(res)),

  // 获取行业列表
  getIndustries: () =>
    fetch(`${API_URL}/api/templates/industries/list`, {
      headers: { ...getAuthHeaders() },
    }).then(res => parseJsonResponse<string[]>(res)),
};
